module.exports = __webpack_public_path__ + "static/media/Kathy.da3bb942.png";